import type { CSSProperties } from "react";

// 인라인 style 문자열("color:red;font-weight:bold")을 React style 객체로 변환한다.
export const parseStyleString = (styleString: string): CSSProperties => {
  return styleString.split(";").reduce<Record<string, string>>((acc, style) => {
    const [property, value] = style.split(":");
    if (property && value) {
      acc[property.trim()] = value.trim();
    }
    return acc;
  }, {}) as CSSProperties;
};
